import * as Actions from "./actions";
import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { SUCCESS, NOTIF_ERROR } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";

export const getStoreList = (search, includeInactive) => (dispatch) => {
    let params = new FormData();
    params.append("pstrSearch", search)
    params.append("pboolWithInactive", includeInactive)
    return ApiService.list(Path.STORE_ROOT, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data.storeList));
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const getStoreById = (id) => () => {
    return ApiService.get(Path.STORE_ROOT + `/${id}`)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const insertStore = (storeDetails, imageFile) => () => {
    const params = new FormData();
    storeDetails = Object.keys(storeDetails).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => {obj[key] = storeDetails[key];return obj;}, {});
    params.append("storeDetails", JSON.stringify(storeDetails));
    params.append("imageFile", imageFile);
    return ApiService.insert(Path.STORE_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const updateStore = (storeDetails, imageFile) => () => {
    const params = new FormData();
    storeDetails = Object.keys(storeDetails).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => {obj[key] = storeDetails[key];return obj;}, {});
    params.append("storeDetails", JSON.stringify(storeDetails));
    params.append("imageFile", imageFile);
    return ApiService.update(Path.STORE_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deleteStore = (id) => () => {
    return ApiService.delete(Path.STORE_ROOT, id)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const sortDraggable = (sortedStores) => (dispatch) => {
    return ApiService.post(Path.STORE_DRAGGABLE, sortedStores)
        .then((response) => {
            if(SUCCESS === response.data.status){
                dispatch(Actions.setList(sortedStores));
            }
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};


export const resetSortDraggable = () => () => {
    return ApiService.post(Path.STORE_RESET_DRAGGABLE)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};
